import Vue from 'vue';

const success = (context, response, bookingId) => {
  context.get_messages(bookingId);
};

const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, bookingId) => {
  return Vue.$http.get(`/sms/mark/as/read?booking_id=${bookingId}`)
    .then(response => {
      if(response && response.status === 200) {
        success(context, response, bookingId);
      }
    }).catch(error => {
      failed(error, context);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/message/markMessageAsRead.js